export default __webpack_public_path__ + "static/media/029-water bottle.051501d9.svg";